<div class="video-intro-block">
  <div class="container-fluid mt-5">
    <div class="row video-row">
      <div class="video-col">
        @if (data.video) {
          <video autoplay [muted]="true" loop class="default-border-radius">
            <source [src]="data.video.url" type="video/mp4" />
          </video>
        }
        @if (data.pdf) {
          <a
            class="btn btn-primary"
            href="{{ data.pdf?.url }}"
            target="_blank"
            >{{ data.downloadPdfLinkText }}</a
          >
        }
      </div>
      <div class="tiles-col">
        @for (
          ctaArticle of data?.linkArticles ?? [];
          track ctaArticle.id ?? $index;
          let i = $index
        ) {
          <a
            class="rounded-tile linkarticle-tile"
            [ngClass]="{
              'background-dark-blue': i % 2 === 0,
              'background-yellow': i % 2 !== 0,
            }"
            [attr.href]="getArticleHref(ctaArticle)"
            [attr.target]="getArticleTarget(ctaArticle)"
            [attr.rel]="getArticleRel(ctaArticle)"
          >
            <span class="linkarticle-copy">
              @if (ctaArticle.title || ctaArticle.description) {
                @if (ctaArticle.title) {
                  <h2>{{ ctaArticle.title }}</h2>
                }
                @if (ctaArticle.description) {
                  <p>{{ ctaArticle.description }}</p>
                }
              } @else {
                @if (getArticleCtaText(ctaArticle); as ctaText) {
                  <span class="linkarticle-label">{{ ctaText }}</span>
                }
              }
            </span>
            <span class="linkarticle-action" aria-hidden="true">
              <i
                class="fa-duotone fa-solid fa-circle-arrow-right fa-duotone-custom-colors"
              ></i>
            </span>
            @if (ctaArticle.title || ctaArticle.description) {
              @if (getArticleCtaText(ctaArticle); as ctaText) {
                <span class="visually-hidden">{{ ctaText }}</span>
              }
            }
          </a>
        }
      </div>
    </div>
  </div>
</div>
